module.exports = __webpack_public_path__ + "static/media/nuance-mobile.975e9692.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/nuance-mobile.jpg
// module id = 54
// module chunks = 0